export const toOADate = function (date) {
    var timezoneOffset = date.getTimezoneOffset() / (60 * 24);
    var msDateObj = date.getTime() / 86400000 + (25569 - timezoneOffset);
    return msDateObj;
};
export const fromOADate = function (oadate) {
    var date = new Date((oadate - 25569) * 86400000);
    var tz = date.getTimezoneOffset();
    return new Date((oadate - 25569 + tz / (60 * 24)) * 86400000);
};
export const addDays = (date, days) => {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};
